import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class PriceRange extends UcoastEl {
	static htmlSelector = 'price-range'
	static selectors = {
		input: '[data-uc-price-range-input]',
		max: '[data-uc-price-range-input="max"]',
		min: '[data-uc-price-range-input="min"]',
	}
	inputs: NodeListOf<HTMLInputElement>
	maxInput: HTMLInputElement
	minInput: HTMLInputElement
	minDisplay: HTMLElement
	maxDisplay: HTMLElement
	touchMin: HTMLButtonElement
	touchMax: HTMLButtonElement
	line: HTMLElement
	minValueLimit: number
	maxValueLimit: number
	minValue: number
	maxValue: number
	step = 0.0
	offset = 0 //26
	startX = 0
	x = 0
	maxX: number
	selectedTouch: HTMLButtonElement | null = null
	initialValue: number
	boundOnMove: (event: MouseEvent | TouchEvent) => void
	boundOnStop: (event: MouseEvent | TouchEvent) => void
	formId: string
	parentForm?: HTMLFormElement
	constructor() {
		super()
		this.maxInput = q.rs(PriceRange.selectors.max, this)
		this.minInput = q.rs(PriceRange.selectors.min, this)
		this.inputs = q.rl(PriceRange.selectors.input, this)
		this.inputs.forEach((element) => element.addEventListener('change', this.onRangeChange.bind(this)))
		this.setMinAndMaxValues()
		this.minDisplay = q.rs('[data-uc-price-range-display="min"]', this)
		this.maxDisplay = q.rs('[data-uc-price-range-display="max"]', this)
		this.minValueLimit = parseFloat(q.ra(this.minInput, 'min'))
		this.maxValueLimit = parseFloat(q.ra(this.maxInput, 'max'))
		this.minValue = parseFloat(this.minInput.value)
		if (isNaN(this.minValue)) this.minValue = parseFloat(q.ra(this.minInput, 'min'))
		this.maxValue = parseFloat(this.maxInput.value)
		if (isNaN(this.maxValue)) this.maxValue = parseFloat(q.ra(this.maxInput, 'max'))
		this.touchMin = q.rs('[data-uc-price-range-touch="min"]', this)
		this.touchMax = q.rs('[data-uc-price-range-touch="max"]', this)
		this.offset = this.touchMin.offsetWidth
		this.line = q.rs('[data-uc-price-range-line]', this)
		this.resetTouchPosition()
		this.maxX = this.offsetWidth - this.touchMax.offsetWidth
		this.initialValue = this.line.offsetWidth - this.offset
		this.setMinValue(this.minValue)
		this.setMaxValue(this.maxValue)
		this.touchMin.addEventListener('mousedown', this.onStart.bind(this))
		this.touchMax.addEventListener('mousedown', this.onStart.bind(this))
		this.touchMin.addEventListener('touchstart', this.onStart.bind(this), { passive: true })
		this.touchMax.addEventListener('touchstart', this.onStart.bind(this), { passive: true })
		this.boundOnMove = this.onMove.bind(this)
		this.boundOnStop = this.onStop.bind(this)
		this.formId = q.ra(this, 'data-uc-select-form-id')
		this.parentForm = q.os(`form[data-uc-select-form-id="${this.formId}"]`)

		console.log({initialValue: this.initialValue})
	}
	reInitializeForSafari() {
		if (this.offset !== 0) return
		this.style.height = '1px'
		this.offsetHeight
		this.removeAttribute('style')
		this.offset = this.touchMin.offsetWidth
		this.resetTouchPosition()
		this.maxX = this.offsetWidth - this.touchMax.offsetWidth
		this.initialValue = this.line.offsetWidth - this.offset
	}

	resetTouchPosition() {
		this.touchMin.style.left = '0'
		this.touchMax.style.left = this.offsetWidth - this.offset + 'px'
		this.line.style.marginLeft = '0px'
		this.line.style.width = this.offsetWidth - this.touchMin.offsetWidth + 'px'
		this.startX = 0
		this.x = 0
	}

	setMinValue(value: number) {
		const ratio = (this.minValue - this.minValueLimit) / (this.maxValueLimit - this.minValueLimit)
		this.touchMin.style.left = Math.ceil(ratio * (this.offsetWidth - this.offset)) + 'px'
		this.line.style.marginLeft = this.touchMin.offsetLeft + 'px'
		this.line.style.width = this.touchMax.offsetLeft - this.touchMin.offsetLeft + 'px'
		this.minValue = value
	}

	setMaxValue(value: number) {
		let ratio = (this.maxValueLimit - this.maxValue) / (this.maxValueLimit - this.minValueLimit)
		if (ratio === 0) ratio = 1;
		//const ratio = (this.maxValue - this.minValueLimit) / (this.maxValueLimit - this.minValueLimit)
		this.touchMax.style.left = Math.ceil(ratio * (this.offsetWidth - this.offset)) + 'px'
		this.line.style.marginLeft = this.touchMin.offsetLeft + 'px'
		this.line.style.width = (this.touchMax.offsetLeft - this.touchMin.offsetLeft).toString() + 'px'
		this.maxValue = value
	}

	onStart(event: MouseEvent | TouchEvent) {
		const currentTarget = q.rct(event)
		let eventTouch: MouseEvent | Touch

		if ('touches' in event) {
			eventTouch = event.touches[0]
		} else {
			eventTouch = event as MouseEvent
		}
		if (!eventTouch) throw new Error('Event touch is not defined')
		if (currentTarget !== this.touchMin && currentTarget !== this.touchMax) {
			console.error('not current target')
		}
		this.x = currentTarget === this.touchMin ? this.touchMin.offsetLeft : this.touchMax.offsetLeft
		this.startX = eventTouch.pageX - this.x
		this.selectedTouch = currentTarget as HTMLButtonElement

		// add event listeners
		document.addEventListener('mousemove', this.boundOnMove)
		document.addEventListener('mouseup', this.boundOnStop)
		document.addEventListener('touchmove', this.boundOnMove)
		document.addEventListener('touchend', this.boundOnStop)
	}

	onStop(_: MouseEvent | TouchEvent) {
		document.removeEventListener('mousemove', this.boundOnMove)
		document.removeEventListener('mouseup', this.boundOnStop)
		document.removeEventListener('touchmove', this.boundOnMove)
		document.removeEventListener('touchend', this.boundOnStop)

		this.selectedTouch = null

		// calculate new value
		this.calculateValue()
		this.minInput.value = this.minValue.toFixed(0)
		this.maxInput.value = this.maxValue.toFixed(0)

		const eventChange = new CustomEvent('input', {
			cancelable: true,
			bubbles: true,
		})
		this.dispatchEvent(eventChange)
	}

	onMove(event: MouseEvent | TouchEvent) {
		//const currentTarget = q.rct(event)
		let eventTouch: MouseEvent | Touch

		if ('touches' in event) {
			eventTouch = event.touches[0]
		} else {
			eventTouch = event as MouseEvent
		}
		if (!eventTouch) throw new Error('Event touch is not defined')
		this.x = eventTouch.pageX - this.startX
		if (this.selectedTouch === this.touchMin) {
			if (this.x > this.touchMax.offsetLeft - this.selectedTouch.offsetWidth) {
				this.x = this.touchMax.offsetLeft - this.selectedTouch.offsetWidth
			} else if (this.x < 0) {
				this.x = 0
			}
			this.selectedTouch.style.left = this.x + 'px'
		} else if (this.selectedTouch === this.touchMax) {
			if (this.x < this.touchMin.offsetLeft + this.touchMin.offsetWidth) {
				this.x = this.touchMin.offsetLeft + this.touchMin.offsetWidth
			} else if (this.x > this.maxX) {
				this.x = this.maxX
			}
			this.selectedTouch.style.left = this.x + 'px'
		}
		this.line.style.marginLeft = this.touchMin.offsetLeft + 'px'
		this.line.style.width = this.touchMax.offsetLeft - this.touchMin.offsetLeft + 'px'

		this.calculateValue()
	}

	onRangeChange(event: Event) {
		const currentTarget = q.rct<Event, HTMLInputElement>(event)
		this.adjustToValidValues(currentTarget)
		this.setMinAndMaxValues()
	}

	setMinAndMaxValues() {
		if (this.maxInput.value) this.minInput.setAttribute('max', this.maxInput.value)
		if (this.minInput.value) this.maxInput.setAttribute('min', this.minInput.value)
		if (this.minInput.value === '') this.maxInput.setAttribute('min', '0')
		if (this.maxInput.value === '') this.minInput.setAttribute('max', q.ra(this.maxInput, 'max'))
	}

	adjustToValidValues(input: HTMLInputElement) {
		const value = Number(input.value)
		const min = Number(q.ra(input, 'min'))
		const max = Number(q.ra(input, 'max'))

		if (value < min) input.value = `${min}`
		if (value > max) input.value = `${max}`
	}

	calculateValue() {
		const newValue = (this.line.offsetWidth - this.offset) / this.initialValue
		const minValue = this.line.offsetLeft / this.initialValue
		const maxValue = minValue + newValue

		this.minValue = minValue * (this.maxValueLimit - this.minValueLimit) + this.minValueLimit
		this.maxValue = maxValue * (this.maxValueLimit - this.minValueLimit) + this.minValueLimit
		this.minDisplay.innerHTML = this.minValue.toFixed(0)
		this.maxDisplay.innerHTML = this.maxValue.toFixed(0)
	}
}
